import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";

const urlProveedor = "Supplier";

export const newProveedor = async ({payload}) =>{
    return axios.post(`${APIURL}/${urlProveedor}`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return getError(Error);
    })
}

export const updateProveedor = async ({payload, idProveedor}) =>{
    return axios.put(`${APIURL}/${urlProveedor}/Information/${idProveedor}`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return getError(Error);
    })
}

export const updateProveedorEstatus = async ({idProveedor, Estatus}) =>{
    return axios.put(`${APIURL}/${urlProveedor}/Information/drop/${idProveedor}/${Estatus}`, {}, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return getError(Error)
    })
}

export const getProveedoresAll = async () =>{
    return axios.get(`${APIURL}/${urlProveedor}/find`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}

export const getProveedorById = async ({idProveedor}) =>{
    return axios.get(`${APIURL}/${urlProveedor}/${idProveedor}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return {};
    })
}

export const getProveedoresMayoristas = async () =>{
    return axios.get(`${APIURL}/${urlProveedor}/wholesaler`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}
/**
 * 
 * TODO: Metodos proveedores usarios
 *  
 */
export const getProveedorUsuarios = async ({idProveedor}) =>{
    return axios.get(`${APIURL}/${urlProveedor}/Users/${idProveedor}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}

export const newProveedorUsuario = async ({payload}) =>{
    return axios.post(`${APIURL}/${urlProveedor}/UserInformation`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return Error.response.data;
    })
}

export const getProveedorUsuarioById = async ({idUsuario}) =>{
    return axios.get(`${APIURL}/${urlProveedor}/User/${idUsuario}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return {};
    })
}